/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* jshint undef: true, unused: true, browser: true, esversion: 6, devel: true */
/* globals jQuery */

var $ = jQuery;

var BixBux = function () {
   function BixBux() {
      _classCallCheck(this, BixBux);

      this.init();
   }

   _createClass(BixBux, [{
      key: 'init',
      value: function init() {
         this.initSlider();
         this.initHeader();
         this.initMobileMenu();
      }
   }, {
      key: 'initSlider',
      value: function initSlider() {
         var slider = $('.c-featured-post');
         var autoplay = slider.data('autoplay');
         var autoplaySpeed = parseInt(slider.data('autoplay-speed'));
         slider.slick({
            autoplay: autoplay,
            autoplaySpeed: autoplaySpeed,
            nextArrow: '<button class="slick-next"><i class="ion-chevron-right"></i></button>',
            prevArrow: '<button class="slick-prev"><i class="ion-chevron-left"></i></button>'
         });
      }
   }, {
      key: 'initHeader',
      value: function initHeader() {
         var schTrigger = $(".search-trigger");
         var schForm = $(".search-form");
         var schInput = schForm.find('input[type="email"]');

         schTrigger.on('click', function () {
            schForm.parents('.site-search').toggleClass('is-active');
            schInput.focus();
         });
      }
   }, {
      key: 'initMobileMenu',
      value: function initMobileMenu() {
         var mainMenu = $(".site-navigation .menu").clone();
         var scLinks = $(".header-item.social-links a").clone();
         var mbMenu = $(".mobile-menu");
         var mbScLinks = $(".mobile-social-links");
         var mbTrigger = $(".mobile-menu-trigger");
         var mbWrap = $(".mobile-menu-wrap");

         mbMenu.prepend(mainMenu);
         mbScLinks.append(scLinks);

         mbTrigger.on('click', function () {
            mbWrap.slideToggle();
         });
      }
   }]);

   return BixBux;
}();

$(document).ready(function () {
   new BixBux();
});

/***/ })
/******/ ]);